import React from 'react'
import PropTypes from 'prop-types'

import Button from '../Button'
import ContentBlock from '../ContentBlock'
import Icon from '../Icon'

import localization from './localization'
import commonLocalization from '../../localization/common'

import styles from './CTA.module.styl'

const CTA = (props) => {
  const { language } = props

  return (
    <ContentBlock center>
      <h2 className={styles.title}>{localization[language].title}</h2>

      <Button type="anchor" size="large" inline to={commonLocalization[language].bookUrl}>
        {localization[language].button} »
      </Button>

      <p className={styles.shareText}>{localization[language].shareText}</p>
      <div className={styles.shareLinks}>
        <a href={localization[language].shareLinks.facebook} target="_blank" rel="nofollow noopener" className={styles.shareLink}><Icon type="facebook" size={32} /></a>
        <a href={localization[language].shareLinks.twitter} target="_blank" rel="nofollow noopener" className={styles.shareLink}><Icon type="twitter" size={32} /></a>
        <a href={localization[language].shareLinks.whatsapp} target="_blank" rel="nofollow noopener" className={styles.shareLink}><Icon type="whatsapp" size={32} /></a>
        <a href={localization[language].shareLinks.mail} className={styles.shareLink}><Icon type="mail" size={32} /></a>
      </div>
    </ContentBlock>
  )
}

CTA.propTypes = {
  language: PropTypes.string.isRequired,
}

export default CTA



// WEBPACK FOOTER //
// ./src/components/CTA/CTA.js